module.exports = __webpack_public_path__ + "a1fef3b365fbdd6dd4b82368f861e6a2.svg";